<template>
  <div>
    <v-flex xs12 sm6 d-flex>
      <v-data-table
        :headers="headers"
        :items="teammeetings"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
    >
        <template slot="items" slot-scope="props">
          <tr @click="$router.push('/teammeetings/' + props.item.id)">
            <td>{{ props.item.meeting_date |moment('DD.MM.YYYY')}}</td>
            <td>Anzeigen</td>
          </tr>
        </template>
        <template slot="no-data">
            <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
        </template>
    </v-data-table>
    </v-flex>
  </div>
</template>

<script>
import apiCall from '../../utils/api'

export default {
  data: () => ({
    headers: [
      {
        text: 'Datum',
        value: 'meeting_date'
      },
      {
        text: 'Anzeigen'
      }
    ],
    pagination: {
      sortBy: 'meeting_date',
      descending: true,
      rowsPerPage: 25
    },
    teammeetings: []
  }),
  created () {
    apiCall({url: '/api/teammeetings', method: 'GET'})
      .then(resp => {
        this.teammeetings = resp
      })
  },
  methods: {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Teammeetings/Index.vue